import React from 'react';
import { Container, Section } from '@grubhubprod/gh-cookbook-react';

export const StickyToolbarContainer: React.FC = ({ children }) => {
  return (
    <Container variant="fluid">
      <Section
        inset="md"
        bg="untintedBackground"
        dimension="2"
        className="navBarFixed"
      >
        {children}
      </Section>
    </Container>
  );
};
